import styled from "styled-components";
const MainContainer = styled.div`
  padding: 0px 16px;
  display: flex;
  flex-direction: column;
  flex: 1;
`;
const LogoIcon = styled.img`
  object-fit: contain;
`;
const LogoContainer = styled.div<{ noBg?: boolean }>`
  height: 70px;
  width: 70px;
  border-radius: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 60px 20px 20px;
`;

const Footer = styled.footer`
  padding: 16px 0;
  margin-top: 15px;
`;

const Content = styled.main<{ type?: string }>`
  flex: 1;
  align-items: center;
  flex-direction: column;
  display: ${(props) => props.type === "center" && "flex"};
`;

const Title = styled.h2`
  font-size: 25px;
  font-weight: bold;
  color: #20564b;
  margin-bottom: 8px;
  line-height: 30px;
`;

const NormalText = styled.p`
  font-size: 20px;
  color: #20564b;
  margin-bottom: 8px;
  line-height: 25px;
`;

const Description = styled.p<{ type?: string }>`
  font-size: 17px;
  color: #848484;
  margin-bottom: 16px;
  line-height: 25px;
  text-align: ${(props) => props.type === "center" && "center"};
`;
const ProceedButton = styled.button<{ disabled?: boolean }>`
  width: 100%;
  padding: 12px;
  font-size: 16px;
  background-color: ${(props) => (props.disabled ? "#d3d3d3" : "#070505")};
  color: ${(props) => (props.disabled ? "#a9a9a9" : "white")};
  border: none;
  border-radius: 4px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: background-color 0.3s;

  
`;

const CustomInput = styled.input`
  padding: 10px 2%;
  margin: 5px 0px;
  border: 0;
  width: 96%;
  border-radius: 5px;
  box-shadow: 0px 0px 2px 0px gray;
`;
export {
  ProceedButton,
  Title,
  Footer,
  Description,
  MainContainer,
  Content,
  LogoContainer,
  LogoIcon,
  NormalText,
  CustomInput,
};
